import type {InterfaceStrings} from './strings'

export const nl: InterfaceStrings = {
    nav: {
        beginSession: 'Beginnen',
        faq: 'Vragen',
        pricing: 'Prijzen',
        legal: 'Juridisch',
        signIn: 'Inloggen',
        viewPricing: 'Prijzen bekijken',
        signOut: 'Uitloggen',
        account: 'Account',
        menu: 'Menu',
        closeMenu: 'Menu sluiten',
        mainNav: 'Hoofdnavigatie',
        sessions: {one: '{n} sessie', other: '{n} sessies'},
    },
    footer: {
        selfHypnosisFor: 'Zelfhypnose bij',
        anxiety: 'Angst',
        sleep: 'Slaapproblemen',
        stress: 'Stress',
        confidence: 'Onzekerheid',
        focus: 'Concentratie',
        learn: 'Achtergrond',
        ericksonian: 'Wat is Ericksoniaanse hypnose',
        aiHow: 'Hoe AI-hypnose werkt',
        vsMeditation: 'Hypnose of meditatie',
        methods: 'Methoden',
        languages: 'Talen',
    },
    page: {
        cta: 'Begin je gratis sessie',
        hint: 'Je eerste sessie is gratis',
        exploreFurther: 'Verder lezen',
        disclaimer:
            'Quies is een wellnesshulpmiddel voor ontspanning en zelfonderzoek. Het is geen medisch hulpmiddel en stelt geen diagnose, behandelt niets en geneest niets. Zit je in een psychische crisis, neem dan contact op met een zorgverlener.',
        transcript: 'Transcript',
        transcriptNote: 'Een fragment uit een echte Quies-sessie, zoals het werd uitgesproken.',
        breadcrumb: 'Kruimelpad',
    },
    pricing: {
        selectPlan: 'Dit pakket kiezen',
        subscribe: 'Abonneren',
        perMonth: 'per maand',
        manageSubscription: 'Abonnement beheren',
        replayFree: 'Een eerdere sessie opnieuw beluisteren is altijd gratis.',
        offerLead: 'Elke sessie begint waar de vorige eindigde.',
    },
    session: {
        chooseLanguage: 'Kies je taal',
        changeLanguage: 'Taal wijzigen',
        changeVoice: 'Stem wijzigen',
        previewVoice: '{voice} beluisteren',
        stopPreview: 'Fragment stoppen',
        continue: 'Verder',
        composing: 'Quies schrijft je sessie',
        preparing: 'Je meditatie wordt voorbereid',
        pickingUp: 'we gaan verder waar je gebleven was',
        today: 'Vandaag',
        yesterday: 'Gisteren',
        loading: 'Laden…',
        showEarlier: 'Eerdere tonen ({count})',
        tryDifferentApproach: 'Een andere weg proberen',
        nothingAdded: 'Niets toegevoegd',
        purchaseConfirmed: 'Aankoop bevestigd',
        firstSessionNote: 'Je eerste sessie is gratis. Je logt in voordat je luistert.',
    },
    threshold: {
        title: 'Log in om te luisteren',
        message: 'Je eerste sessie is gratis. Geen kaart nodig.',
        google: 'Doorgaan met Google',
        sendLink: 'Stuur me een inloglink',
        sending: 'Versturen…',
        emailLabel: 'E-mailadres',
        or: 'of',
        waitingTitle: 'Kijk in je mailbox',
        waitingBody: 'We hebben een inloglink gestuurd naar {email}.',
        sendAgain: 'Opnieuw sturen',
        googleInstead: 'Liever inloggen met Google',
        codeLabel: 'Of typ de code van 6 cijfers uit de e-mail',
        codeSubmit: 'Doorgaan',
        codeSubmitting: 'Controleren…',
        codeWrong: 'Deze code klopt niet.',
        codeDead: 'Deze code werkt niet meer. Gebruik de link in de e-mail of vraag een nieuwe aan.',
        errors: {
            invalidEmail: 'Vul een geldig e-mailadres in.',
            rateLimited: 'Te veel pogingen. Probeer het over een paar minuten opnieuw.',
            sessionError: 'Er ging iets mis met je inlog. Ververs de pagina en probeer het opnieuw.',
            sendFailed: 'De e-mail kon niet worden verstuurd. Probeer het opnieuw.',
            sessionExpired: 'Je inlog is verlopen. Ververs de pagina en probeer het opnieuw.',
            generic: 'Er ging iets mis. Probeer het opnieuw.',
        },
    },
    player: {
        play: 'Afspelen',
        pause: 'Pauzeren',
        playAgain: 'Opnieuw afspelen',
        seek: 'Positie',
        eyesClosed: 'Ogen dicht',
        openEyes: 'Ogen openen',
        paused: 'Gepauzeerd',
        unavailable: 'Audio niet beschikbaar',
        untitled: 'Quies-sessie',
    },
    failure: {
        turnFailed: 'Er ging aan onze kant iets mis. Je antwoord is bewaard.',
        reconnecting: 'Opnieuw verbinden…',
        refusalTitle: 'Laten we een andere weg nemen',
        refusal: 'Op een deel van je bericht kon geen antwoord komen. Formuleer het anders, of stuur het opnieuw.',
        openElsewhere: 'Deze sessie is ook in een ander venster geopend.',
        serviceDown: 'Quies is op dit moment niet bereikbaar. Niets van wat je hebt gedaan is verloren.',
        sessionsUsedTitle: 'Je sessies zijn gebruikt',
        voiceFailedTitle: 'Je meditatie is geschreven',
        voiceFailed: 'De stem kon er zojuist niet bij gemaakt worden. Er gaat niets verloren, en opnieuw inspreken kost niets.',
        voiceStopped: 'De stem viel halverwege stil. Ze kan verdergaan waar ze was gebleven.',
        streamMissing: 'Je meditatie is klaar, maar ze is niet op deze pagina aangekomen.',
        tapToListen: 'Tik om te luisteren',
        fileFailed: 'Deze opname wil niet afspelen. De meditatie kan kosteloos opnieuw worden ingesproken.',
        recordingGone: 'Deze opname wordt niet meer bewaard.',
        purchaseCancelled: 'Aankoop geannuleerd. Er is niets afgeschreven.',
        purchasePending: 'Je betaling is bevestigd. Je sessies doen er langer over dan normaal om aan te komen.',
        checkoutFailed: 'De betaling kon niet worden afgerond. Er is niets afgeschreven.',
        sessionEnded: 'Deze sessie is tot een einde gekomen.',
        busy: 'Quies is op dit moment erg druk. Je antwoord is bewaard; probeer het over een minuut opnieuw.',
        tooLong: 'Deze sessie is langer geworden dan Quies kan bevatten. Je krijgt haar terug.',
        notSaved: 'Deze stap kon niet worden bewaard. Probeer het opnieuw om verder te gaan waar je was.',
        meditationRefused:
            'Deze meditatie kon niet worden geschreven zoals gevraagd. Formuleer het anders, of begin opnieuw: je krijgt deze sessie terug.',
        meditationRefusedUncharged:
            'Deze meditatie kon niet worden geschreven zoals gevraagd. Formuleer het anders, of begin opnieuw.',
        linkExpired: 'Je inloglink is verlopen. Vraag een nieuwe aan.',
        oauthFailed: 'Het inloggen werd onderbroken. Probeer het opnieuw.',
        offline: 'Je bent offline. Je antwoord wordt verstuurd zodra je weer verbinding hebt.',
        voiceChanged: 'Je stem is niet meer beschikbaar; een andere stem spreekt deze meditatie uit.',
        voiceReturned: 'De stem kon nog steeds niet worden gemaakt. Je hebt deze sessie teruggekregen.',
        voiceFailedAgain: 'De stem kon nog steeds niet worden gemaakt.',
        voiceResuming: 'De stem gaat verder…',
        voiceLimited: 'Er zijn dit uur al meerdere meditaties voor je ingesproken. Probeer het wat later opnieuw.',
        tryAgain: 'Opnieuw proberen',
        rephrase: 'Anders formuleren',
        resume: 'Hervatten',
        voiceAgain: 'Opnieuw inspreken',
        listen: 'Luisteren',
        continue: 'Verder',
        begin: 'Een sessie beginnen',
        signIn: 'Inloggen',
        checkAgain: 'Opnieuw controleren',
        sendLink: 'Inloglink sturen',
        useEmail: 'Liever e-mail gebruiken',
    },
}
